import { render, staticRenderFns } from "./SituationsConfigAdd.vue?vue&type=template&id=78dec8e0&scoped=true"
import script from "./SituationsConfigAdd.vue?vue&type=script&lang=js"
export * from "./SituationsConfigAdd.vue?vue&type=script&lang=js"
import style0 from "./SituationsConfigAdd.vue?vue&type=style&index=0&id=78dec8e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dec8e0",
  null
  
)

export default component.exports